'use client';

import Image from 'next/image';
import Link from 'next/link';
import fblogo from '@/assets/icons/common/fb-logo.svg';
import instalogo from '@/assets/icons/common/insta-logo.svg';
import linkedinlogo from '@/assets/icons/common/linkedin-logo.svg';
import youtubelogo from '@/assets/icons/common/yt-logo.svg';
import xlogo from '@/assets/icons/common/x-logo.svg';
import { FB_LINK, IG_LINK, LINKEDIN_LINK, TWITTER_LINK, YT_LINK } from '@/constants/apiConstant';

import footerData from '@/components/ui/footer/footerData.json';

import ListData from './ListData';

const Footer = () => {
  const socialLinks = [
    { href: FB_LINK, label: 'Visit CollegeHai on Facebook', icon: fblogo },
    { href: IG_LINK, label: 'Visit CollegeHai on Instagram', icon: instalogo },
    { href: TWITTER_LINK, label: 'Visit CollegeHai on Twitter', icon: xlogo },
    { href: YT_LINK, label: 'Visit CollegeHai on YouTube', icon: youtubelogo },
    { href: LINKEDIN_LINK, label: 'Visit CollegeHai on LinkedIn', icon: linkedinlogo },
  ];

  return (
    <footer className="bg-primary text-white text-sm">
      <div className="max-w-screen-xl mx-auto px-4 py-6">
        <ListData
          topIIMsCol1={footerData.topIIMsCol1}
          topIIMsCol2={footerData.topIIMsCol2}
          topIITs={footerData.topIITs}
          mbaCities={footerData.mbaCollegesCities}
          mbaStates={footerData.mbaCollegesStates}
          pgdmCities={footerData.pgdmCollegesCities}
          pgdmStates={footerData.pgdmCollegesStates}
          topManagementCol1={footerData.topManagementCol1}
          topManagementCol2={footerData.topManagementCol2}
        />
        <div className="flex flex-col lg:flex-row justify-between items-center mt-8 gap-y-4 border-t border-gray-400 pt-8">
          <div className="flex gap-4 justify-between items-center text-center">
            <Link href="/about-us" className="hover:underline text-xs lg:text-base">
              About Us
            </Link>
            <Link href="/contact-us" className="hover:underline  text-xs lg:text-base">
              Contact Us
            </Link>
            <Link href="/terms-and-condition" className="hover:underline text-xs lg:text-base">
              Terms & Conditions
            </Link>
            <Link href="/privacy-policy" className="hover:underline text-xs lg:text-base">
              Privacy Policy
            </Link>
          </div>

          <div className="flex gap-3">
            {socialLinks.map(({ href, label, icon }) => (
              <Link
                key={label}
                href={href}
                rel="nofollow"
                aria-label={label}
                className="bg-white text-black rounded-full hover:bg-gray-200 transition"
              >
                <Image src={icon} alt={label ?? 'label'} className="size-6" />
              </Link>
            ))}
          </div>
        </div>

        <div className="text-xs text-center my-4 ">
          © 2025 CollegeHai | Unifyra Internet Pvt. Ltd. All rights reserved.
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;
